/* react-hooks/exhaustive-deps */
import { useUserSuggestions } from '../../../utils/queries/corporateUsers';
import ErrorText from '../../Reusable/ErrorText';
import * as Yup from 'yup';
import { Form, message } from 'antd';

import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
  Button,
  Label,
} from 'reactstrap';
import '../../Reusable/gridStyle.css';

import { Formik, Field, ErrorMessage } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAddUserToQueueMutation } from 'utils/queries/corporateQueue';

// const { Option } = Select;

export default function AddToQueueModel({
  isModalVisible = false,
  corporateId,
  chargerId,
  closeAddToQueue,
  triggerRefreshList,
}) {
  const initialFormValue = {
    EMAIL: '',
    CUSTOMER_ID: '',
  };
  /**
   * Form validation
   */
  const validationSchema = Yup.object({
    EMAIL: Yup.string().required('Please enter email.'),
    NAME: Yup.string().required('Please enter name.'),
  });

  const [query, setQuery] = useState('');
  const formRef = useRef(null);
  // const [searchField, setSearchField] = useState('');
  const [users, setUsers] = useState([]);
  const {
    data: userResults,
    isLoading: userSuggestionsLoading,
    isSuccess: userSuggestionsSuccess,
  } = useUserSuggestions(query, corporateId, 0); // 0: Normal User, 1: Admin

  const [formValues, setFormValues] = useState(initialFormValue);
  const [noUserFound, setNoUserFound] = useState(false);
  const { mutateAsync, isLoading } = useAddUserToQueueMutation();

  useEffect(() => {
    if (userResults?.length > 0) setUsers(userResults);
  }, [userResults]);

  useEffect(() => {
    setNoUserFound(false);
  }, []);

  useEffect(() => {
    if (userSuggestionsLoading) setNoUserFound(false);
    if (userSuggestionsSuccess) setNoUserFound(true);
    setTimeout(() => setNoUserFound(false), 5000);
  }, [userSuggestionsLoading, userSuggestionsSuccess]);

  const getHeading = () => 'Add to Queue';

  const triggerClose = () => {
    setFormValues(initialFormValue);
    closeAddToQueue();
  };

  const onBlurSearchInput = (searchQuery, type) => {
    setQuery(searchQuery);
    // setSearchField(type);
  };

  const onSubmit = (values, formReset) => {
    const request = {
      // ID: values.ID,
      CUSTOMER_ID: values.CUSTOMER_ID,
      CHARGER_ID: chargerId,
    };

    mutateAsync(request).then(
      (resp) => {
        if (resp.data && resp.status === 200) {
          setFormValues(initialFormValue);
          formReset({ values: initialFormValue });
          setUsers([]);
          triggerRefreshList();
          closeAddToQueue();
          message.success(
            `User added to queue at position ${resp?.data?.position} successfully.`,
            5,
          );
        } else {
          message.error(
            resp?.data?.message || 'Something went wrong. Please try again',
          );
        }
      },
      (error) => {
        message.error(
          error?.response?.data?.message ||
            'Something went wrong. Please try again',
        );
        setFormValues(initialFormValue);
        formReset({ values: initialFormValue });
        setUsers([]);
        triggerRefreshList();
        closeAddToQueue();
      },
    );
  };

  return (
    <Modal isOpen={isModalVisible} toggle={triggerClose}>
      <ModalHeader
        style={{ padding: '5px 10px', margin: 10 }}
        toggle={closeAddToQueue}
      >
        <div style={{ fontSize: '20px' }}>{`${getHeading()}`}</div>
      </ModalHeader>
      <ModalBody>
        <Formik
          innerRef={formRef}
          initialValues={formValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={(values, form) => {
            onSubmit(values, form);
          }}
        >
          {({ values, setFieldValue, handleSubmit, resetForm }) => (
            <Form
              className="relative"
              layout="vertical"
              // onFinish={() => handleSubmit()}
            >
              <Row gutter={[14, 14]}>
                <Col sm="12" md="12" lg="12">
                  <Form.Item
                    label={
                      <div>
                        Please provide Email OR Phone of user and hit ENTER
                        <span className="mandatorystar">*</span>
                      </div>
                    }
                  >
                    <Field
                      as={Input}
                      name="EMAIL"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter')
                          onBlurSearchInput(e.target.value, 'EMAIL');
                      }}
                      onChange={(e) => {
                        setFieldValue('EMAIL', e?.target?.value);
                      }}
                    />
                    <ErrorMessage name="EMAIL" component={ErrorText} />
                    {noUserFound && users?.length === 0 && (
                      <span style={{ color: '#ff4d4f' }}>
                        No matching verified user found for the corporate.
                      </span>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              {users?.length > 0 && (
                <Row gutter={[14, 14]}>
                  <Col span={24}>
                    <Label style={{ marginBottom: 10 }}>
                      Please select user from {users?.length} matching results{' '}
                      <span className="mandatorystar">*</span>
                    </Label>

                    <Field
                      as="select"
                      name="CUSTOMER_ID"
                      onChange={(e) => {
                        setFieldValue('CUSTOMER_ID', e?.target?.value);
                      }}
                      style={{
                        width: '100%',
                        height: '43px',
                        borderRadius: '6px',
                        padding: '8px',
                        backgroundColor: 'white',
                        border: '1px solid #d4d9df',
                        color: '#8b9bac',
                      }}
                    >
                      <option value=""></option>
                      {users?.map((user) => (
                        <option key={user.ID} value={user.ID}>
                          {`${user?.NAME} (${user?.PHONE_NUMBER})`}
                        </option>
                      ))}
                    </Field>

                    <ErrorMessage name="CUSTOMER_ID" component={ErrorText} />
                  </Col>
                </Row>
              )}

              {users?.length > 0 && (
                <Row gutter={[14, 14]}>
                  <Col
                    span={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button
                      style={{
                        color: '#fff',
                        background: '#1890ff',
                        marginTop: 20,
                      }}
                      htmlType="submit"
                      loading={isLoading}
                      disabled={isLoading}
                      onClick={() => onSubmit(values, resetForm)}
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              )}
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
}
